"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setConfigAndEncrypt = exports.getUrl = exports.setIsEncryptParams = exports._initConfig = void 0;
/* 加密v5中间件 */
var helper_1 = require("../../../core/helper");
var request_1 = __importDefault(require("../request"));
var constant_1 = require("../../../core/constant");
var helper_factory_1 = __importDefault(require("../../helper/helper-factory"));
var common_encrypt_v5_1 = require("../../encrypt/common-encrypt-v5");
var helper_factory_2 = __importDefault(require("../../helper/helper-factory"));
var encrypt = new common_encrypt_v5_1.Encrypt();
var config;
var _initConfig = function () { return __awaiter(void 0, void 0, void 0, function () {
    var domin, promise, response, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                domin = (0, helper_1.getBaseUrlV5)();
                promise = request_1.default.load({
                    url: domin + constant_1.ENCRYPT_V5_PATH,
                    method: 'get',
                    headers: helper_factory_1.default.getAiServerHeadersV5(),
                })[0];
                return [4 /*yield*/, promise];
            case 1:
                response = _a.sent();
                config = response.data;
                config && encrypt.init(config);
                return [3 /*break*/, 3];
            case 2:
                e_1 = _a.sent();
                // TODO1: 业务接口加解密失败错误码：401426002 出现这个错误码时，可能是后端配置的密钥过期了，前端需要重新请求/encryption/info接口获取新的RSA公钥
                // TODO2: 接口报错后，不走加解密，隔一分钟再次请求/encryption/info接口 done,待全端自测
                /*
                  其他调整todo：
                  1. expires字段定义改为有效时长，单位是秒；
                  2. 业务接口请求头要带上公钥信息； X-Encryption-Public-Key
                  3. 业务接口的响应头会带上密钥剩余的有效时长。
                */
                encrypt.setLoadErrStatus(true);
                console.log('[ai sdk initConfig error]', e_1);
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); };
exports._initConfig = _initConfig;
var setIsEncryptParams = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var data, headers, isEncrypt, _a, method, _isEncrypt, _headers, _data, _b, content, _encryptHeaders, e_2;
    var _c;
    return __generator(this, function (_d) {
        switch (_d.label) {
            case 0:
                data = params.data, headers = params.headers, isEncrypt = params.isEncrypt, _a = params.method, method = _a === void 0 ? '' : _a;
                _isEncrypt = typeof isEncrypt !== 'undefined' ? isEncrypt : !((_c = window.__CONFIG__) === null || _c === void 0 ? void 0 : _c.disableAiEncrypt);
                _headers = helper_factory_2.default.getObjKeysMerged(__assign({ 'Content-Type': 'application/json' }, helper_factory_2.default.getAiServerHeadersV5()), headers);
                _data = typeof data === 'object' ? JSON.stringify(data) : data;
                _d.label = 1;
            case 1:
                _d.trys.push([1, 4, , 5]);
                if (!_isEncrypt) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, exports.setConfigAndEncrypt)(data)];
            case 2:
                _b = _d.sent(), content = _b.content, _encryptHeaders = __rest(_b, ["content"]);
                if (encrypt.loadErrStatus()) {
                    _isEncrypt = false;
                    throw new Error('[ai sdk load info error]');
                }
                _headers = helper_factory_2.default.getObjKeysMerged(_headers, _encryptHeaders);
                _data = method.toLocaleLowerCase() === 'get' ? data : content;
                _d.label = 3;
            case 3: return [3 /*break*/, 5];
            case 4:
                e_2 = _d.sent();
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/, {
                    _headers: _headers,
                    _data: _data,
                    _decrypt: _isEncrypt ? encrypt.decrypt : undefined
                }];
        }
    });
}); };
exports.setIsEncryptParams = setIsEncryptParams;
var getUrl = function (url, baseUrl) {
    if (!url.startsWith('http')) {
        return "".concat(baseUrl || (0, helper_1.getBaseUrlV5)()).concat(url);
    }
    return url;
};
exports.getUrl = getUrl;
var setConfigAndEncrypt = function (data) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!config) {
                    config = encrypt.getEncryptConfig();
                }
                if (!((!config.public_key || config.expires < Date.now()) && !encrypt.loadErrStatus())) return [3 /*break*/, 2];
                return [4 /*yield*/, (0, exports._initConfig)()];
            case 1:
                _a.sent();
                _a.label = 2;
            case 2: return [4 /*yield*/, encrypt.encrypt({
                    content: data,
                    isEncryptHeaders: true
                })];
            case 3: return [2 /*return*/, _a.sent()];
        }
    });
}); };
exports.setConfigAndEncrypt = setConfigAndEncrypt;
